declare const Docxtemplater;
declare const JSZip;
declare const JSZipUtils;

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { Contract } from '../model/contract';
import ExportUtils from '../utils/export';
import { environment } from './../../environments/environment';

import { NgxSpinnerService } from 'ngx-spinner';


const PRE = '<w:p><w:pPr><w:spacing w:before="0" w:after="0" w:beforeAutospacing="0" w:afterAutospacing="0"/></w:pPr><w:r><w:t>';

const POST = '</w:t></w:r></w:p>';
const NEW_LINE = '<w:br/>';


@Injectable()
export class WordToPdfExportService {

  constructor(private http: HttpClient,private spinner: NgxSpinnerService) { }

  /**
   * Exports contract as DocX.
   * @param {Contract} contract
   */
  exportAsDocxToPdf = (contract: Contract) => {

    
  var mojrawxml : string = '';
  var mojrawstatements : string = '';
  var predzadnji : string = '';
  var mojrawend : string = '';


    var client = this.http;
 

    function cleanText(text) {
      return text.replace('  ', ' ');
    }

    JSZipUtils.getBinaryContent("assets/contract-template.docx", function (error, content) {

      if (error) { throw error };

      let zip = new JSZip(content);
      let doc = new Docxtemplater().loadZip(zip).setOptions({paragraphLoop:true});

      let contractData = {
        title: contract.title,
        sides: [],
        headline: contract.headline,
        articles: [],
        date_place: "",
        signatures: [],
        noArticleTitle: contract.noArticleTitle,
        noArticleNumbers: contract.noArticleNumbers,
        mojrawxml : '',
        mojrawend : '',
        predzadnji : ''
      };

      // Sides
      for (let i = 0; i < contract.sides.length; i++) {
        if(contract.sides[i].inputs.find(e => e.value && e.value !== "")) {

          // if next sig is existing but not required and empty, add delimiter
          let showDelimiter = false;
          if ((i + 1) < contract.sides.length && contract.sides[i + 1].inputs.find(e => e.value && e.value !== "")) {
            showDelimiter = true;
          }

          // Create data array
          var sideData = {
            name: contract.sides[i].inputs.map(e => (e.placeholder && e.placeholder == 'OIB' ? 'OIB: ' : '') + (e.value ? e.value : '')).join(', '),
          }
          var attrs = ["label", "prefix", "suffix", "delimiter"];
          attrs.forEach(attr => {
            if(contract.sides[i][attr] !== undefined && contract.sides[i][attr] != '') {
              sideData[attr] = contract.sides[i][attr];
            }
          });
          
          // Push it to contractData
          contractData.sides.push(sideData);
        }
      }


      mojrawxml = '';

      // Articles
      for (let i = 0; i < contract.articles.length; i++) {

        let enumerate = !contract.noArticleNumbers;
        let num = ExportUtils.getArticleNumber(contract, i);

        // let article = {
        //   articleTitle: contract.articles[i].title,
        //   number: (enumerate ? 'Članak ' : '') + (!contract.articles[i].dummy ? ((enumerate ? num : ExportUtils.romanize(num)) + '.') : ''),
        //   hasNumber: !contract.noArticleTitle && !contract.articles[i].static,
        //   statements: [],
        // };

        let article = {
          PREFIX:  '<w:pPr><w:keepNext/></w:pPr>' ,
          SUFIX:  '</w:pPr>' ,
          article_title: contract.articles[i].title,
          has_title: !contract.articles[i].static && !contract.noArticleTitle && contract.articles[i].title,
          number: (enumerate ? 'Članak ' : '') + (!contract.articles[i].dummy ? ((enumerate ? num : ExportUtils.romanize(num)) + '.') : ''),
          has_number: !contract.noArticleTitle && !contract.articles[i].static,
          statements: [],
        };

        // Signatures
        /*
        if (contract.articles[i].type === 3) {

          let tableStart =
            `<w:tbl>
              <w:tblPr>
                <w:tblStyle w:val="TableGrid"/>
                <w:tblW w:w="5000" w:type="pct"/>
                <w:tblBorders>
                  <w:top w:val="none"/>
                  <w:start w:val="none"/>
                  <w:bottom w:val="none"/>
                  <w:end w:val="none"/>
                  <w:insideH w:val="none"/>
                  <w:insideV w:val="none"/>
                </w:tblBorders>
              </w:tblPr>
              <w:tblGrid>
                <w:gridCol w:w="2880"/>
                <w:gridCol w:w="2880"/>
                <w:gridCol w:w="2880"/>
              </w:tblGrid>
              <w:tr>`;

          let tableEnd = `</w:tr></w:tbl>`;

          let emptyCol = `<w:tc><w:tcPr><w:tcW w:w="2880" w:type="dxa"/></w:tcPr><w:p></w:p></w:tc>`;

          let signatures = '';

          if (contract.sides.length === 1) {

            signatures += emptyCol + emptyCol;

            if (contract.sides[0].inputs.find(e => e.value && e.value !== "")) {
              signatures += genSignature(contract.sides[0]);
            } else {
              signatures += emptyCol;
            }
          }

          if (contract.sides.length === 2) {

            if (contract.sides[0].inputs.find(e => e.value && e.value !== "")) {
              signatures += genSignature(contract.sides[0]);
            } else {
              signatures += emptyCol;
            }

            signatures += emptyCol;

            if (contract.sides[1].inputs.find(e => e.value && e.value !== "")) {
              signatures += genSignature(contract.sides[1]);
            } else {
              signatures += emptyCol;
            }
          }

          if (contract.sides.length === 3) {

            for (let i = 0; i < contract.sides.length; i++) {
              if (contract.sides[i].inputs.find(e => e.value && e.value !== "")) {
                signatures += genSignature(contract.sides[i]);
              } else {
                signatures += emptyCol;
              }
            }

          }

          article.statements.push({ rawXml: tableStart + signatures + tableEnd });
        }
        */


        
        // Signatures
        if (contract.articles[i].type === 3) {

          let tableStart =
            `<w:tbl>
            <w:tblPr>
              <w:tblStyle w:val="TableGrid"/>
              <w:tblW w:w="5000" w:type="pct"/>
              <w:tblBorders>
                <w:top w:val="none"/>
                <w:start w:val="none"/>
                <w:bottom w:val="none"/>
                <w:end w:val="none"/>
                <w:insideH w:val="none"/>
                <w:insideV w:val="none"/>
              </w:tblBorders>
            </w:tblPr>
            <w:tblGrid>
              <w:gridCol w:w="2880"/>
              <w:gridCol w:w="2880"/>
              <w:gridCol w:w="2880"/>
            </w:tblGrid>
              <w:tr>`;

          let tableEnd = `</w:tr></w:tbl>`;

          let signatures = '';
          for (let i = 0; i < contract.sides.length; i++) {
            if (contract.sides[i].inputs.find(e => e.value && e.value !== "")) {
              let headline = contract.sides[i].signature;
              let underlineone = '';
              let underlinetwo = '';
              let underlinethree = '';
              
              if (i==0) {
                underlineone = contract.sides[i].inputs.filter(e => e.value && e.inSignature).map(e => (e.signaturelabel ? e.signaturelabel + ':' : '') + e.value).join(", ");
              }
              if (i==1){
                underlinetwo = contract.sides[i].inputs.filter(e => e.value && e.inSignature).map(e => (e.signaturelabel ? e.signaturelabel  + ':' : '') + e.value ).join(", "); 
              }
              if (i==2){
                underlinethree = contract.sides[i].inputs.filter(e => e.value && e.inSignature).map(e => (e.signaturelabel  ? e.signaturelabel + ':' : '') + e.value).join(", ");
              }

              signatures +=
              `<w:tc>
              <w:tcPr>
                <w:tcW w:w="2880" w:type="dxa"/>
              </w:tcPr>
              <w:p>
               <w:pPr> 
                <w:jc w:val="right" /> 
                <w:keepNext/>
                  <w:spacing w:before="480" w:after="120"/>
                </w:pPr>
                <w:r>
                <w:rPr>
                <w:rFonts w:ascii="Arial" w:hAnsi="Arial" w:eastAsia="ＭＳ Ｐゴシック" w:cs="Arial" />
                <w:sz w:val="24" />
                <w:szCs w:val="24" />
                <w:lang w:eastAsia="ja-JP" />    
                </w:rPr>
                  <w:t>` + headline + 
                  `</w:t>
                </w:r>
              </w:p>
              <w:p>
                <w:pPr> 
                <w:jc w:val="right" />
                <w:keepNext/>
                  <w:spacing w:before="480" w:after="120"/>
                </w:pPr>
                <w:r>
                <w:rPr>
                <w:rFonts w:ascii="Arial" w:hAnsi="Arial" w:eastAsia="ＭＳ Ｐゴシック" w:cs="Arial" />
                <w:sz w:val="24" />
                <w:szCs w:val="24" />
                <w:lang w:eastAsia="ja-JP" />    
                </w:rPr>
                  <w:t>____________________</w:t>
                </w:r>
              </w:p>
              <w:p>
                <w:pPr> 
                <w:jc w:val="right" />
                <w:keepNext/>
                  <w:spacing w:before="10" w:after="10"/>
                </w:pPr>
                <w:r> 
                <w:rPr>
                <w:rFonts w:ascii="Arial" w:hAnsi="Arial" w:eastAsia="ＭＳ Ｐゴシック" w:cs="Arial" />
                <w:sz w:val="24" />
                <w:szCs w:val="24" />
                <w:lang w:eastAsia="ja-JP" />    
                </w:rPr>
                <w:t>` + underlineone + 
                `</w:t>
                </w:r>
                <w:r>
                <w:rPr>
                <w:rFonts w:ascii="Arial" w:hAnsi="Arial" w:eastAsia="ＭＳ Ｐゴシック" w:cs="Arial" />
                <w:sz w:val="24" />
                <w:szCs w:val="24" />
                <w:lang w:eastAsia="ja-JP" />    
                </w:rPr>
                <w:t>` + underlinetwo + 
                `</w:t>
                </w:r>
                <w:r>
                <w:rPr>
                <w:rFonts w:ascii="Arial" w:hAnsi="Arial" w:eastAsia="ＭＳ Ｐゴシック" w:cs="Arial" />
                <w:sz w:val="24" />
                <w:szCs w:val="24" />
                <w:lang w:eastAsia="ja-JP" />    
                </w:rPr>
                <w:t>` + underlinethree + 
                `</w:t>
                </w:r>
              </w:p>
         
             
        
            </w:tc>`
              }
          }

          article.statements.push({ text: '', rawXml: tableStart + signatures + tableEnd });
          predzadnji = tableStart + signatures + tableEnd ;
        }


        // Statements
        mojrawstatements = '';
        for (let j = 0; j < contract.articles[i].statements.length; j++) {
          if (contract.articles[i].statements[j].type === 'input') {
            let statement = '';

            for (let k = 0; k < contract.articles[i].statements[j].parts.length; k++) {
              if (contract.articles[i].statements[j].parts[k].type === 'input' || contract.articles[i].statements[j].parts[k].type === 'textarea') {
                statement += contract.articles[i].statements[j].parts[k].value + ' ';
              } else if (contract.articles[i].statements[j].parts[k].type === 'text' || contract.articles[i].statements[j].parts[k].type ==='textarea' ) {
                statement += contract.articles[i].statements[j].parts[k].content + ' ';
              } else if (contract.articles[i].statements[j].parts[k].type === 'date') {
                statement += new Date(contract.articles[i].statements[j].parts[k].value).toLocaleDateString() + ' ';
              }
            }

            article.statements.push({ text: statement });
             mojrawstatements = mojrawstatements + statement; //****kk

            } else if (contract.articles[i].statements[j].type === 'text' || contract.articles[i].statements[j].type === 'textarea' ) {
              article.statements.push({ text: contract.articles[i].statements[j].content });
            mojrawstatements = mojrawstatements + contract.articles[i].statements[j].content ; //****kk
          } else if (contract.articles[i].statements[j].type === 'choice') {
            if (contract.articles[i].statements[j].editable === true) {
              article.statements.push({ text: contract.articles[i].statements[j].value });
              mojrawstatements = mojrawstatements + contract.articles[i].statements[j].value ; //****kk

            } else {
              let statement = '';

              let selectedChoice = parseInt(contract.articles[i].statements[j].value);
              for (let k = 0; k < contract.articles[i].statements[j].choices[selectedChoice].parts.length; k++) {
                if (contract.articles[i].statements[j].choices[selectedChoice].parts[k].type === 'input' || contract.articles[i].statements[j].choices[selectedChoice].parts[k].type === 'textarea') {
                  statement += contract.articles[i].statements[j].choices[selectedChoice].parts[k].value + ' ';
                } else if (contract.articles[i].statements[j].choices[selectedChoice].parts[k].type === 'text' || contract.articles[i].statements[j].choices[selectedChoice].parts[k].type === 'textarea' ) {
                  statement += contract.articles[i].statements[j].choices[selectedChoice].parts[k].content + ' ';
                } else if (contract.articles[i].statements[j].choices[selectedChoice].parts[k].type === 'date') {
                  statement += new Date(contract.articles[i].statements[j].choices[selectedChoice].parts[k].value).toLocaleDateString() + ' ';
                }
              }
                
              article.statements.push({ text: statement});
              mojrawstatements = mojrawstatements + statement ; //****kk

            }
          }
        }

        /*
        // Reset dates and center them
        if (contract.articles[i].type === 2) {
          article.statements[0].rawXml = `<w:p></w:p><w:p><w:pPr><w:jc w:val="center" /></w:pPr><w:r><w:t>`+article.statements[0].text+`</w:t></w:r></w:p>`;
          delete article.statements[0].text;
        }

        // Add empty space (rows) if defined
        if(contract.articles[i].addRows && contract.articles[i].addRows > 0) {
          article['emptySpace'] = Array(contract.articles[i].addRows + 1).join(`<w:p><w:r></w:r></w:p>`);
        }
*/
        contractData.articles.push(article);




//----------------kk
        if (contract.articles[i].type != 3 && contract.articles[i].type != 2 && contract.articles[i].type != 4  ) {

          if (typeof article.article_title == 'undefined') { article.article_title = ''}
        
          let titlered = '';
          if(article.article_title != '') {
            titlered =  `<w:p><w:pPr><w:keepNext/> <w:spacing w:after="80" w:line="270" w:lineRule="auto" />  </w:pPr>
            <w:r>
                    <w:rPr>
                    <w:b w:val="true" />
                    </w:rPr>
                    <w:rPr>
                    <w:rFonts w:ascii="Arial" w:hAnsi="Arial" w:eastAsia="ＭＳ Ｐゴシック" w:cs="Arial" />
                    <w:sz w:val="24" />
                    <w:szCs w:val="24" />
                    <w:lang w:eastAsia="ja-JP" />    
                          </w:rPr>
                <w:t>` + article.article_title  +
                `</w:t>
              </w:r>
            </w:p>`
          }
        //   <w:spacing w:after="200" w:line="276" w:lineRule="auto" />  >>> https://c-rex.net/projects/samples/ooxml/e1/Part4/OOXML_P4_DOCX_spacing_topic_ID0EA1OM.html
        // font height https://stackoverflow.com/questions/17690672/how-to-read-all-the-font-sizes-used-in-a-docx
        // font name https://stackoverflow.com/questions/44081942/how-to-find-out-what-font-family-is-used-by-a-paragraph-in-ooxml
          let articlenumber = '';
          if(article.number != '') {
            articlenumber =  `<w:p><w:pPr><w:jc w:val="center" /><w:keepNext/> <w:spacing w:after="80" w:line="160" w:lineRule="auto" /> 
            </w:pPr>
            <w:r>
            <w:rPr>
            <w:b w:val="true" />
            </w:rPr>
            <w:rPr>
            <w:rFonts w:ascii="Arial" w:hAnsi="Arial" w:eastAsia="ＭＳ Ｐゴシック" w:cs="Arial" />
            <w:sz w:val="24" />
            <w:szCs w:val="24" />
            <w:lang w:eastAsia="ja-JP" />    
            </w:rPr>
              <w:t>` + article.number +
              `</w:t>
            </w:r>
          </w:p>`
          }
        
        
        
                mojrawxml = mojrawxml + titlered
              +  articlenumber
              +  `<w:p> <w:pPr>  <w:spacing w:after="240" w:line="276" w:lineRule="auto" /> 
               </w:pPr>
              <w:r>
              <w:rPr>
              <w:rFonts w:ascii="Arial" w:hAnsi="Arial" w:eastAsia="ＭＳ Ｐゴシック" w:cs="Arial" />
              <w:sz w:val="24" />
              <w:szCs w:val="24" />
              <w:lang w:eastAsia="ja-JP" />    
              </w:rPr>
                <w:t>` + mojrawstatements.split('\r\n').join('</w:t><w:br/><w:t>') +
                `</w:t>
              </w:r>
            </w:p>`
        }
        
        
        if (contract.articles[i].type == 2 ) {
          mojrawxml = mojrawxml + `<w:p><w:pPr><w:jc w:val="center" /></w:pPr><w:r>
        
          <w:rPr>
          <w:rFonts w:ascii="Arial" w:hAnsi="Arial" w:eastAsia="ＭＳ Ｐゴシック" w:cs="Arial" />
          <w:sz w:val="24" />
          <w:szCs w:val="24" />
          <w:lang w:eastAsia="ja-JP" />    
          </w:rPr>
          
          <w:t>` + mojrawstatements +   `</w:t></w:r></w:p>`
        }
        if (contract.articles[i].type == 4 ) {
          mojrawend = mojrawend + `<w:p><w:pPr></w:pPr><w:r>
        
          <w:rPr>
          <w:rFonts w:ascii="Arial" w:hAnsi="Arial" w:eastAsia="ＭＳ Ｐゴシック" w:cs="Arial" />
          <w:sz w:val="24" />
          <w:szCs w:val="24" />
          <w:lang w:eastAsia="ja-JP" />    
          </w:rPr>
        
          <w:t>` + mojrawstatements.split('\r\n').join('</w:t><w:br/><w:t>')  +   `</w:t></w:r></w:p>`
        }
        
        // ************************ end of kk



      }


      contractData.mojrawxml = mojrawxml; //**kk */
      contractData.mojrawend = mojrawend;
      contractData.predzadnji = predzadnji;

      console.log('mojrawxml',mojrawxml)
      console.log('contractData',contractData)

      doc.setData(contractData);

      try {
        // render the document
        doc.render()
      } catch (error) {
        let e = {
          message: error.message,
          name: error.name,
          stack: error.stack,
          properties: error.properties,
        }
        console.log(JSON.stringify({ error: e }));
        // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
        throw error;
      }

      // Output the document using Data-URI
      let out = doc.getZip().generate({
        type: "blob",
        mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      const uploadData = new FormData();
      uploadData.append('contract', out, 'generated.docx');
      client
        .post(environment.convert_api_url, uploadData, { responseType: 'blob' as 'json'})
        .subscribe(
          (response: any) => {
              let dataType = response.type;
              let binaryData = [];
              binaryData.push(response);

              let downloadLink = document.createElement('a');
              downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
              downloadLink.setAttribute('download', contract.name + ".pdf");
              document.body.appendChild(downloadLink);
              downloadLink.click();

              (<any>window).spinner.hide();

          }
        );

      // Save document
      //saveAs(out, contract.name + ".docx");

    });
  }

}



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/service/word-to-pdf-export.service.ts